import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  ViedocButtonElement,
  ViedocDialogElement,
} from "../../../../secure/elements/ViedocReactElements";
import _ from "underscore";
import IndividualMilestone from "./IndividualMilestone/IndividualMilestone";
import * as documentActions from "../../../../store/actions/documentActions";
import * as templateActions from "../../../../store/actions/templateActions";
import Loader from "../../shared/Loader/Loader";
import APP_CONST from "../../../shared/constants";
import { getMilestoneGroupLabel } from "../../../../../utils/utilsHelper";

const MilestoneViewDialog = ({ type, setViewMilestone }) => {
  const { t } = useTranslation();
  const {
    mileStoneInfoList,
    milestoneCount,
    viewMilestoneListLoading,
    mileStoneLastModified,
    tmfStructureData,
    milestoneSequenceChangeFail,
    isChangeSequenceLoading,
  } = useSelector((store) => store.template);

  const dispatch = useDispatch();

  const onHide = () => {
    setViewMilestone(false);
    dispatch(templateActions.addNewMilestoneHideError());
  };

  const [showToaster, setShowToaster] = useState(false);
  const [isIndividualMilestoneVisible, setIsIndividualMilestoneVisible] =
    useState(false);

  const [isAddMilestoneVisible, setIsAddMilestoneVisible] = useState(false);

  const [milestoneInfo, setMilestoneInfo] = useState({});

  // render constant header
  const adminViewDialogHeader = [
    {
      className: "Rtable-cell replay-link-cell",
      label: t("ADMIN.TABLEHEADER_TRIALDESCRIPTION"),
      id: 1,
    },
    {
      className: "Rtable-cell pdf-cell",
      label: t("ADMIN.TABLEHEADER_COUNTRYDESCRIPTION"),
      id: 2,
    },
    {
      className: "Rtable-cell pdf-cell",
      label: t("ADMIN.TABLEHEADER_SITEDESCRIPTION"),
      id: 3,
    },
  ];

  const tableArray = [
    {
      id: 1,
      label: APP_CONST.MILESTONE_GROUP_LIST[0],
      class: "pt-25 bt-1",
      className: "wrapper bb-1",
    },
    {
      id: 2,
      label: APP_CONST.MILESTONE_GROUP_LIST[1],
      class: "pt-25",
      className: "wrapper bb-1",
    },
    {
      id: 3,
      label: APP_CONST.MILESTONE_GROUP_LIST[2],
      class: "pt-25 pb-25",
      className: "wrapper",
    },
    {
      id: 4,
      label: APP_CONST.MILESTONE_GROUP_LIST[3],
      class: "pt-20 sem-pri-color",
      className: "wrapper",
    },
  ];

  useEffect(() => {
    if (!_.isEmpty(milestoneSequenceChangeFail)) {
      setShowToaster(true);
    }
  }, [milestoneSequenceChangeFail]);

  const renderTableHeader = () => {
    return (
      <>
        <section className="Rtable-row Rtable-row--head bb-1 f13">
          <div className="Rtable-cell date-cell">#</div>
          <div className="Rtable-cell topic-cell">
            {t("ADMIN.TABLEHEADER_ID")}
          </div>
          <div className="Rtable-cell access-link-cell">
            {t("ADMIN.TABLEHEADER_NAME")}
          </div>
          {adminViewDialogHeader.map((fieldValue) => (
            <Fragment key={fieldValue.id}>
              <div className={fieldValue.className}>{fieldValue.label}</div>
            </Fragment>
          ))}
          <div className="Rtable-cell view-cell"></div>
        </section>
      </>
    );
  };

  const renderComponentHeader = () => {
    return (
      <section className="milestone-popup-header d-flex bb-1 pb-20 pl-30 pt-20">
        <div className="d-flex">
          <p>{milestoneCount}</p>
          <p>{t("ADMIN.ADMINTAB_MILESTONE")}</p>
        </div>
        {type === "edit" && (
          <ViedocButtonElement
            size="small"
            variant="success"
            onClick={() => setIsAddMilestoneVisible(true)}
            title={t("TMF.TEXT_ADDNEW")}
          >
            <div>
              <viedoc-icon name="empty" />
              <viedoc-icon name="close" />
              <p>{t("TMF.TEXT_ADDNEW")}</p>
            </div>
          </ViedocButtonElement>
        )}
      </section>
    );
  };

  const individualMilestoneHandler = (item) => {
    setIsIndividualMilestoneVisible(true);
    setMilestoneInfo(item);
    dispatch(documentActions.getMilestoneArtifactCount(item.id));
  };

  const changeSequenceHandler = (milestoneInfo) => {
    const sequencePayload = {
      id: milestoneInfo.id,
      lastModifiedOn: mileStoneLastModified
        ? mileStoneLastModified
        : tmfStructureData.lastmodifiedon,
    };

    dispatch(templateActions.changeMilestoneSequence(sequencePayload));
  };

  const renderMilestoneValue = (groupName) => {
    const sortedList = _.sortBy(mileStoneInfoList[groupName], "order");
    return (
      <>
        {sortedList &&
          sortedList?.map((item, index) => {
            let isEditedOrDeleted = [5, 6, 7].includes(item.action);
            let isDeleted = [4, 7].includes(item.action);
            return (
              !(item.isDeleted && item.action === 0) && (
                <section className="Rtable-row Rtable-row--body" key={index}>
                  <article className="Rtable-cell date-cell">
                    <div className="Rtable-cell--content date-content ">
                      <span
                        className={`webinar-date ${
                          isEditedOrDeleted || item.action === 8
                            ? "edit-color"
                            : ""
                        }`}
                      >
                        {isDeleted
                          ? "NA"
                          : item.order < 10
                          ? `0${item.order}`
                          : item.order}
                      </span>
                    </div>
                  </article>

                  <article
                    className={`Rtable-cell topic-cell ${
                      isEditedOrDeleted ? "edit-color" : ""
                    } ${isDeleted ? "line-through" : ""}`}
                  >
                    <div className="Rtable-cell--content title-content">
                      {item.identifier}
                    </div>
                  </article>

                  <article
                    className={`Rtable-cell access-link-cell ${
                      isEditedOrDeleted ? "edit-color" : ""
                    } ${isDeleted ? "line-through" : ""}`}
                  >
                    <div className="Rtable-cell--content access-link-content">
                      {item.name}
                    </div>
                  </article>

                  <article
                    className={`Rtable-cell replay-link-cell ${
                      isEditedOrDeleted ? "edit-color" : ""
                    } ${isDeleted ? "line-through" : ""}`}
                  >
                    <div className="Rtable-cell--content replay-link-content">
                      {item.trialDescription || "-"}
                    </div>
                  </article>

                  <article
                    className={`Rtable-cell Rtable-cell--foot pdf-cell ${
                      isEditedOrDeleted ? "edit-color" : ""
                    } ${isDeleted ? "line-through" : ""}`}
                  >
                    <div className="Rtable-cell--content pdf-content">
                      {item.countryDescription || "-"}
                    </div>
                  </article>

                  <article
                    className={`Rtable-cell Rtable-cell--foot pdf-cell ${
                      isEditedOrDeleted ? "edit-color" : ""
                    } ${isDeleted ? "line-through" : ""}`}
                  >
                    <div className="Rtable-cell--content pdf-content">
                      {item.siteDescription || "-"}
                    </div>
                  </article>

                  {
                    <article className="Rtable-cell Rtable-cell--foot view-cell">
                      {!isDeleted && (
                        <div className="Rtable-cell--content milestone-others-cellcontent">
                          {type === "edit" && index !== 0 && (
                            <div
                              className="down-arrow"
                              onClick={() => changeSequenceHandler(item)}
                              title={t("ADMIN.TEXT_CHANGE_SEQUENCE")}
                            >
                              <viedoc-icon name="down_arrow" />
                            </div>
                          )}
                          <ViedocButtonElement
                            size="small"
                            variant="info"
                            onClick={() => individualMilestoneHandler(item)}
                            title={type === "view"
                              ? t("ADMIN.TEXT_VIEW")
                              : t("ADMIN.TEXT_EDIT")}
                          >
                            {type === "view"
                              ? t("ADMIN.TEXT_VIEW")
                              : t("ADMIN.TEXT_EDIT")}
                          </ViedocButtonElement>
                        </div>
                      )}
                    </article>
                  }
                </section>
              )
            );
          })}
      </>
    );
  };

  const renderViewMilestoneSection = () => {
    return (
      <section className="milestone-popup">
        {renderComponentHeader()}
        <div className="milestone-popup-body">
          {tableArray.map((item) => (
            <Fragment key={item.id}>
              <p className={item.class}>{getMilestoneGroupLabel(item.label)}</p>
              <div className={item.className}>
                <div className="Rtable Rtable--5cols Rtable--collapse">
                  {renderTableHeader()}
                  {renderMilestoneValue(item.label)}
                </div>
              </div>
            </Fragment>
          ))}
        </div>
      </section>
    );
  };

  const renderToaster = (message) => {
    return (
      showToaster && (
        <viedoc-toaster
          onClick={() => {
            setShowToaster(false);
            dispatch(templateActions.addNewMilestoneHideError());
          }}
          variant="error"
          prefix-icon="warning"
          toasterMsg={message}
        ></viedoc-toaster>
      )
    );
  };

  return (
    <ViedocDialogElement
      size="large"
      open
      preventCloseByClick
      class="admin-view"
      onHide={() => onHide()}
    >
      <header className="pl-10" slot="header">
        <p className="f21 mt-5">
          {type === "view"
            ? t("ADMIN.ADMINTAB_VIEWMILESTONE")
            : t("ADMIN.ADMINTAB_EDITMILESTONE")}
        </p>
      </header>
      {isChangeSequenceLoading ? (
        <Loader width={"100%"} borderRadius />
      ) : (
        <>
          {renderToaster(
            milestoneSequenceChangeFail
              ? milestoneSequenceChangeFail
              : t("ADMIN.TOAST_SOMETHINGWENTWRONG")
          )}
          {viewMilestoneListLoading ? (
            <Loader width={"100%"} borderRadius />
          ) : (
            renderViewMilestoneSection()
          )}
          {isIndividualMilestoneVisible && (
            <IndividualMilestone
              type={type}
              milestoneInfo={milestoneInfo}
              setIsIndividualMilestoneVisible={setIsIndividualMilestoneVisible}
            />
          )}
          {isAddMilestoneVisible && (
            <IndividualMilestone
              type="add"
              milestoneInfo={milestoneInfo}
              setIsAddMilestoneVisible={setIsAddMilestoneVisible}
            />
          )}
        </>
      )}
      <footer slot="footer"></footer>
    </ViedocDialogElement>
  );
};

export default MilestoneViewDialog;
